<template>
  <div class="app flex-row align-items-center" id="registerSafePlaceUser-page">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="12 text-center mt-3">
          <h3 style="color: white; font-family: 'Times New Roman'">
            BỘ VĂN HÓA, THỂ THAO VÀ DU LỊCH
          </h3>
          <h2
            style="
              color: white;
              font-weight: 700;
              font-family: 'Times New Roman';
            "
          >
            TỔNG CỤC DU LỊCH
          </h2>
          <img src="img/logo_VN.png"  style="transform: scale(0.7)"  alt />
          <h2
            style="
              color: #fff200;
              margin-top: 10px;
              font-family: 'Times New Roman';
              font-weight: bold;
            "
          >
            CHƯƠNG TRÌNH
          </h2>
          <h3
            class="title"
            style="
              color: #fff200;
              margin-bottom: 20px;
              font-family: 'Times New Roman';
              font-weight: bold;
            "
          >
            KÍCH CẦU DU LỊCH NỘI ĐỊA - DU LỊCH VIỆT NAM AN TOÀN, HẤP DẪN
          </h3>
        </b-col>
        <b-col md="8" sm="8">
          <b-card no-body class="mx-4">
            <b-card-body class="p-4">
              <b-form>
                <h4 class="text-center" style="font-weight: bold">Đăng ký</h4>
                <h4 class="text-center" style="font-weight: bold">
                  "Điểm đến an toàn COVID - 19"
                </h4>
                <h6 class="text-center text-danger mb-3" style="font-weight: bold">
                  Tất cả các trường dưới đây bắt buộc phải khai báo thông tin
                </h6>
                <b-alert
                  variant="danger"
                  dismissible
                  :show="mData.dataDefault.showDismissibleAlert"
                  @dismissed="mData.dataDefault.showDismissibleAlert = false"
                  >{{ mData.dataDefault.error }}</b-alert
                >
                <b-alert
                  variant="success"
                  dismissible
                  :show="mData.dataDefault.showDismissibleAlertSuccess"
                  @dismissed="
                    mData.dataDefault.showDismissibleAlertSuccess = false
                  "
                  >{{ mData.dataDefault.success }}</b-alert
                >

                <el-form
                  :model="mData.dataForm"
                  :rules="mData.validForm"
                  ref="myForm"
                  label-width="100%"
                  label-position="top"
                  @submit.native.prevent
                  class="mt-1"
                >
                  <!-- <el-form-item label prop="email" class="el-form-item--medium">
                    <el-input
                      prefix-icon="el-icon-user"
                      placeholder="Email*"
                      v-model.trim="mData.dataForm.email"
                      autocomplete="off"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item label prop="pass" class="el-form-item--medium">
                    <el-input
                      prefix-icon="el-icon-unlock"
                      placeholder="Mật khẩu*"
                      type="password"
                      v-model.trim="mData.dataForm.pass"
                      clearable
                      autocomplete="off"
                      show-password
                    ></el-input>
                  </el-form-item>
                  <el-form-item label prop="repass" class="el-form-item--medium">
                    <el-input
                      prefix-icon="el-icon-lock"
                      placeholder="Gõ lại mật khẩu*"
                      type="password"
                      v-model.trim="mData.dataForm.repass"
                      clearable
                      autocomplete="off"
                      show-password
                    ></el-input>
                  </el-form-item>-->
                  <el-form-item label prop="ten" class="el-form-item--medium">
                    <el-input
                      prefix-icon="el-icon-edit"
                      placeholder="Tên đơn vị*"
                      v-model="mData.dataForm.ten"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="" prop="tinh_id">
                    <el-select
                      @change="changeProvinceHandler"
                      v-model="mData.dataForm.tinh_id"
                      placeholder="Tỉnh/Thành phố*"
                      filterable
                    >
                      <el-option
                        v-for="item in mData.dataDefault.provinceList"
                        :key="item.id"
                        :label="item.type + ' ' + item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="" prop="huyen_id">
                    <el-select
                      @change="changeDistrictHandler"
                      v-model="mData.dataForm.huyen_id"
                      placeholder="Quận/Huyện*"
                      filterable
                    >
                      <el-option
                        v-for="item in mData.dataDefault.districtList"
                        :key="item.id"
                        :label="item.type + ' ' + item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="" prop="xa_id">
                    <el-select
                      v-model="mData.dataForm.xa_id"
                      placeholder="Phường/Xã*"
                      filterable
                    >
                      <el-option
                        v-for="item in mData.dataDefault.communeList"
                        :key="item.id"
                        :label="item.type + ' ' + item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    label
                    prop="dia_chi"
                    class="el-form-item--medium"
                  >
                    <el-input
                      prefix-icon="el-icon-location"
                      placeholder="Địa chỉ đơn vị*"
                      v-model="mData.dataForm.dia_chi"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label
                    prop="ho_ten"
                    class="el-form-item--medium"
                  >
                    <el-input
                      prefix-icon="el-icon-edit"
                      placeholder="Họ tên người đại diện*"
                      v-model="mData.dataForm.ho_ten"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label
                    prop="chuc_vu"
                    class="el-form-item--medium"
                  >
                    <el-input
                      prefix-icon="el-icon-edit"
                      placeholder="Chức vụ*"
                      v-model="mData.dataForm.chuc_vu"
                      clearable
                    ></el-input>
                  </el-form-item>                                    
                  <el-form-item
                    label
                    prop="dien_thoai"
                    class="el-form-item--medium"
                  >
                    <el-input
                      prefix-icon="el-icon-phone"
                      placeholder="Số điện thoại di động người đăng ký*"
                      v-model="mData.dataForm.dien_thoai"
                      clearable
                    ></el-input>
                    <span class="text-danger mb-2">
                      *Hiện tại hệ thống mới hỗ trợ các nhà mạng viettel, mobifone, vinaphone.
                    </span>
                  </el-form-item>
                  <el-form-item
                    label
                    prop="so_giay_to"
                    class="el-form-item--medium"
                  >
                    <el-input
                      prefix-icon="el-icon-postcard"
                      placeholder="Số CMTND/CCCD/Hộ chiếu người đăng ký*"
                      v-model="mData.dataForm.so_giay_to"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item label prop="loai" class="el-form-item--medium">
                    <el-select
                      @change="selectLoai"
                      v-model="mData.dataForm.loai"
                      :placeholder="'Chọn loại hình*'"
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="item in mData.dataDefault.listLoaiHinh"
                        :key="item.code"
                        :label="item.text"
                        :value="item.code"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item  v-if="mData.dataDefault.stateLoai"   prop="cslt_dichvu">
                    <!-- <el-select multiple filterable v-model="hi" placeholder="Select">
                      <el-option
                        v-for="item in this.mData.dataDefault.listCSLTDichVu"
                        :key="item.id"
                        :label="item.id"
                        :value="item.id">
                      </el-option>
                    </el-select> -->
                    <el-select v-model="mData.dataForm.cslt_dichvu" multiple placeholder="Chọn dịch vụ cơ sở lưu trú*">
                      <el-option
                        v-for="item in mData.dataDefault.listCSLTDichVu"
                        :key="item.id"
                        :label="item.ten.vi"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <!-- multi -->
                  <el-form-item
                    label
                    prop="email"
                    class="el-form-item--medium"
                  >
                    <el-input
                      prefix-icon="el-icon-edit"
                      placeholder="Email (Không bắt buộc)"
                      v-model="mData.dataForm.email"
                      clearable
                    ></el-input>
                  </el-form-item>   

                  <el-form-item
                    label
                    prop="ma_so_thue"
                    class="el-form-item--medium"
                  >
                    <el-input
                      prefix-icon="el-icon-edit"
                      placeholder="Mã số thuế (Không bắt buộc)"
                      v-model="mData.dataForm.ma_so_thue"
                      clearable
                    ></el-input>
                  </el-form-item>    
                  <el-form-item
                    label
                    prop="website"
                    class="el-form-item--medium"
                  >
                    <el-input
                      prefix-icon="el-icon-edit"
                      placeholder="Website (Không bắt buộc)"
                      v-model="mData.dataForm.website"
                      clearable
                    ></el-input>
                  </el-form-item>                                      

                  <!-- <el-form-item label prop="challenge_token" class="el-form-item--medium">
                    <el-input                      
                      prefix-icon="el-icon-phone"
                      placeholder="Challenge Token"
                      v-model="mData.dataForm.challenge_token"
                      clearable
                      name="recaptcha" id="recaptcha"
                    ></el-input>
                  </el-form-item>-->

                  <el-form-item class="text-center">
                    <el-button
                      type="success"
                      @click="fn_submitForm()"
                      v-ladda
                      native-type="submit"
                      >Đăng ký</el-button
                    >
                  </el-form-item>
                  <!--
                  <el-divider>Hoặc</el-divider>
                  <el-form-item class="text-center mb-0">
                    <el-button
                      type="primary"
                      @click="fn_goDangNhap()"
                      v-ladda
                      native-type="submit"
                      >Đăng nhập</el-button
                    >
                    <p class="mb-0 text-center">(Nếu bạn đã có tài khoản)</p>
                  </el-form-item>
                  -->
                </el-form>

                <!-- <b-col md="12" class="text-center">
                  <b-link to="/auth/login">Quay lại trang đăng nhập</b-link>
                </b-col>-->
              </b-form>
            </b-card-body>
            <!-- <b-card-footer class="p-4">
              <b-row>
                <b-col cols="6">
                  <b-button block class="btn btn-facebook"><span>facebook</span></b-button>
                </b-col>
                <b-col cols="6">
                  <b-button block class="btn btn-twitter" type="button"><span>twitter</span></b-button>
                </b-col>
              </b-row>
            </b-card-footer>-->
          </b-card>
        </b-col>
        <b-col md="12" class="text-center mt-3">
          <h5
            style="
              color: white;
              margin-bottom: 5px;
              font-family: 'Times New Roman';
            "
          >
            THÔNG TIN LIÊN HỆ, HỖ TRỢ:
          </h5>
          <p class="text" style="color: white; font-family: 'Times New Roman'">
            Điện thoại (zalo/viber):
            <a style="color: #ffffff" href="tel:0906150276">0906150276</a>;
            Email:
            <a style="color: #ffffff" href="mailto:titc@vietnamtourism.gov.vn"
              >titc@vietnamtourism.gov.vn</a
            >;
          </p>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
 <!--<script src="https://www.google.com/recaptcha/api.js?render=6LfOhN4UAAAAAE-A6tdTZk3q8w2mmYXPm5Ga2E19"></script>
<script>
    grecaptcha.ready(function() {
        grecaptcha.execute('6LfOhN4UAAAAAE-A6tdTZk3q8w2mmYXPm5Ga2E19', {
            action: 'contact'
        }).then(function(token) {
            if (token) {
                document.getElementById('recaptcha').value = token;
            }
        });
    });
</script>-->
<!--<script>
export default {
  name: 'Register'
}
</script>-->

<script>
// import AuthService from "../../service/AuthService";
import AccountApi from "../../moduleApi/AccountApi";
import CauHinhApi from "../../moduleApi/CauHinhApi";
import LanguageService from "../../service/LanguageService";
import ValidService from "../../service/ValidService";
import MethodService from "../../service/MethodService";
import DataService from "../../service/DataService";
import AuthService from "../../service/AuthService";
import ProvinceApi from '../../moduleApi/ProvinceApi';
import DistrictApi from '../../moduleApi/DistrictApi';
import CommuneApi  from '../../moduleApi/CommuneApi';
import CSLTDichVu from '../../moduleApi/CSLTDichVu'; 
import DiemDenAnToanApi from '../../moduleApi/DiemDenAnToanApi';
import ProfileApi from '../../moduleApi/ProfileApi'; 

// import { VueReCaptcha } from 'vue-recaptcha-v3'
// Vue.use(VueReCaptcha, { siteKey: '6LfOhN4UAAAAAE-A6tdTZk3q8w2mmYXPm5Ga2E19' });

let firstProvince = {
  id: '',
  type: '',
  name: 'Chọn tỉnh/thành phố',
  code: ''
};
let firstDistrict = {
  id: '',
  type: '',
  name: 'Chọn quận/huyện',
  code: ''
};
let firstCommune = {
  id: '',
  type: '',
  name: 'Chọn phường/xã',
  code: ''
};

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      mData: {
        dataDefault: {
          error: "",
          showDismissibleAlert: false,
          success: "",
          showDismissibleAlertSuccess: false,
          // site_key:'',
          listLoaiHinh: MethodService.copyObject(DataService.loaiHinhRegister),
          provinceList: [],
          districtList: [],
          communeList: [],
          listCSLTDichVu:[],
          loai: ['entertainment','international_travel','tourist_carriers','domestic_travel','camping','shopping','restaurant','tourist_area','tourist_attraction'],
          stateLoai: false
        },
        dataForm: {
          // email: "",
          // pass: "",
          // repass: "",
          ten: "",
          dien_thoai: "",
          tinh_id: "",
          huyen_id: "",
          xa_id: "",
          dia_chi: "",
          so_giay_to: "",
          loai: "",
          nguon: "web",
          cslt_dichvu:null,
          // gioi_tinh: "",
          // challenge_token: ""
        },
        validForm: {
          // email: [ValidService.required, ValidService.checkEmail],
          // pass: [ValidService.required, ValidService.checkLength(6)],
          // repass: [ValidService.required, ValidService.checkLength(6)],
          ten: [ValidService.requiredChange],
          dien_thoai: [ValidService.requiredChange, ValidService.checkPhone],
          dia_chi: [ValidService.requiredChange],
          so_giay_to: [ValidService.requiredChange, ValidService.pattern(/^[0-9a-zA-Z]*$/, 'Giá trị không hợp lệ! Chỉ chấp nhận chữ số, chữ cái.')],
          loai: [ValidService.requiredChange],
          tinh_id: [ValidService.requiredChange],
          huyen_id: [ValidService.requiredChange],
          xa_id: [ValidService.requiredChange],
          cslt_dichvu:[ValidService.requiredChange],
          ho_ten: [ValidService.requiredChange],
          chuc_vu: [ValidService.requiredChange],
          email: [ValidService.checkEmail],
          // gioi_tinh: [],
          // challenge_token: []
        },
      },
    };
  },
  methods: {
    selectLoai(){
      if(this.mData.dataDefault.loai.includes(this.mData.dataForm.loai)==false){
        this.mData.dataDefault.stateLoai=true;
      }else{
        this.mData.dataDefault.stateLoai=false;
      }

    },
    fn_submitForm() {
      this.$refs["myForm"].validate((valid) => {
        if (valid) {
          // if (this.mData.dataForm.pass != this.mData.dataForm.repass) {
          //   this.mData.dataDefault.showDismissibleAlert = true;
          //   this.mData.dataDefault.error =
          //     "Mật khẩu và nhập lại mật khẩu không khớp";
          //   MethodService.stopLadda();
          //   return;
          // }

          // console.log(this.mData.dataForm);
          //   debugger;
          this.mData.dataForm.dien_thoai =
            "84" +
            this.mData.dataForm.dien_thoai.substring(
              this.mData.dataForm.dien_thoai.length - 9
            );
          // debugger;
            AccountApi.registerSafePlaceUser(this.mData.dataForm)
            .then(async (res) => {
              // this.mData.dataDefault.showDismissibleAlertSuccess = true;
              // this.mData.dataDefault.success = "Bạn hãy kiểm tra email để lấy lại mật khẩu";
              // debugger;
                // AuthService.login(res.result.account, res.result.password, false)
                // .then((res) => {

                // })
                // .catch((error) => {
                //   this.mData.dataDefault.showDismissibleAlert = true;
                //   this.mData.dataDefault.error =
                //   LanguageService.lang.login_error;
                // });
                try {
                  await AuthService.login(res.result.account, res.result.password, false);
                  if(this.mData.dataDefault.loai.includes(this.mData.dataForm.loai)){
                    this.redirectToForm(res.result.id);
                  }
                  else {
                    this.$router.push({ name: "Admin-DangKyDDAT" });
                  }
                  // debugger;
                } catch (error) {
                  this.mData.dataDefault.showDismissibleAlert = true;
                  this.mData.dataDefault.error =
                  LanguageService.lang.login_error;
                }
              // this.fn_resetForm();
            })
            .catch((error) => {
              this.mData.dataDefault.showDismissibleAlert = true;
              console.log('ERROR : ',error.toString());
              if (
                error.toString().replace("MushroomError:", "").trim() ==
                "Ma so thue nay da dang ky. Vui long lien he tong dai 19006888 de duoc ho tro."
              ) {
                this.mData.dataDefault.error =
                  "Mã số thuế này đã đăng ký. Vui lòng liên hệ số 0906150276 để được hỗ trợ.";
                toastr.error('Mã số thuế này đã đăng ký');
              } else if(
                error.toString().replace("MushroomError:", "").trim() ==
                "Ten va dia chi nay da dang ky. Vui long lien he tong dai 19006888 de duoc ho tro."
              ) {
                toastr.error('Tên và địa chỉ này đã đăng ký');
                this.mData.dataDefault.error =
                  "Tên và địa chỉ này đã đăng ký. Vui lòng liên hệ số 0906150276 để được hỗ trợ.";
              } else {
                this.mData.dataDefault.error =
                  "Đăng ký người dùng không thành công";
                toastr.error('Đăng ký người dùng không thành công');
              }
            });
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    async redirectToForm(id) {
      let dataFilter = {
        filters: "nguoi_tao_id:in:" + id,
      };
      let ddat = await DiemDenAnToanApi.list(dataFilter);
      if (ddat.result.length > 0) {
        this.$router.push({
          name: "Admin-DangKyDDAT-update",
          params: { id: ddat.result[0].id },
        });
      }
      
    },
    async getProvinceList() {
      try {
        const provinceList = await ProvinceApi.list({limit: 200, sort: "type,index"});
        provinceList.result.unshift(firstProvince);
        this.mData.dataDefault.provinceList = provinceList.result;
      } catch (error) {
        console.log('error', error);
      }

      try {
          const listCSLTDichVu = await CSLTDichVu.list();
          this.mData.dataDefault.listCSLTDichVu= listCSLTDichVu.result;
          // console.log(`{{ this.mData.dataDefault.listCSLTDichVu: }}`,this.mData.dataDefault.listCSLTDichVu)
      }
      catch (e) {
          console.error("Có lỗi: %o", e);
      }      

    },
    async getDistrictList(provinceId) {
      if (!provinceId)
      {
        this.mData.dataDefault.districtList = [firstDistrict];
        return;
      }
      try {
        if (provinceId) {
          const districtList = await DistrictApi.list({
            filters: [`provinceId=${provinceId}`],
            limit: 200
          });
          districtList.result.unshift(firstDistrict);
          this.mData.dataDefault.districtList = districtList.result;
        }
      } catch (error) {
        console.log('error', error);
      }
    },
    async getCommuneList(districtId) {

      if (!districtId)
      {
        this.mData.dataDefault.communeList = [firstCommune];
        return;
      }
      try {
        if (districtId) {
          const communeList = await CommuneApi.list({
            filters: [`districtId=${districtId}`],
            fields: "id,name,code,type",
            limit: 200
          });
          communeList.result.unshift(firstCommune);
          this.mData.dataDefault.communeList = communeList.result;
        }
      } catch (error) {
        console.log('error', error);
      }
    },
    changeProvinceHandler(province) {
      this.mData.dataDefault.districtList = [firstDistrict];
      this.mData.dataDefault.communeList = [firstCommune];
      this.mData.dataForm.huyen_id = "";
      this.mData.dataForm.xa_id = "";

      this.getDistrictList(province);
    },
    changeDistrictHandler(district) {
      this.mData.dataDefault.communeList = [firstCommune];
      this.mData.dataForm.xa_id = "";

      this.getCommuneList(district);
    },
    async recaptcha() {
      // (optional) Wait until recaptcha has been loaded.
      // await this.$recaptchaLoaded()

      // Execute reCAPTCHA with action "register".
      const token = await this.$recaptcha("register");
      this.mData.dataForm.challenge_token = token;

      // Do stuff with the received token.
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },
    async fn_initData() {
      // let resSitekey = await CauHinhApi.list({ filters: "code:in:site_key_captcha" });
      // if (resSitekey) {
      //   this.mData.dataDefault.site_key = resSitekey.result[0].value;
      // }
      // this.recaptcha();

      await this.getProvinceList();
    },
    fn_goDangNhap() {
      this.$router.push({
        name: "Auth",
        // query: {
        //   filters: "doi_tuong_danh_gia_id:in:" + row.id
        // }
      });
    },
    fn_go() {
      this.$router.go(-1);
    },
  },

  mounted() {
    this.fn_initData();
  },
  created() {},
};
</script>
<style scoped>
#registerSafePlaceUser-page {
  background-image: url("~/img/background.jpg");
  background-size:cover;
}
@media screen and (max-width: 767px) {
  h3 {
    font-size: 16px;
  }
  h2 {
    font-size: 17px;
  }
  h4{
    font-size: 16px;
  }
  h5 {
    font-size: 14px;
  }
  .text {
    font-size: 12px;
  }
}
</style>